"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ListFilter = _interopRequireDefault(require("@/components/ListFilter"));
var _CloseCoupon = _interopRequireDefault(require("./modules/CloseCoupon.vue"));
var _DeleteCoupon = _interopRequireDefault(require("./modules/DeleteCoupon.vue"));
var _CopyLink = _interopRequireDefault(require("./modules/CopyLink.vue"));
var _fliterConfig = _interopRequireDefault(require("./fliterConfig.js"));
var _paginationEffect = _interopRequireDefault(require("@/utils/paginationEffect"));
var _pageCache = require("@/utils/pageCache");
var _enum = require("../../enum");
var _api = require("../api");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    ListFilter: _ListFilter.default,
    CopyLinkVue: _CopyLink.default,
    CloseCouponVue: _CloseCoupon.default,
    DeleteCouponVue: _DeleteCoupon.default
  },
  data: function data() {
    return _objectSpread(_objectSpread({
      companyAppStatus: _enum.companyAppStatus,
      listLoading: false,
      downloadingCouponIds: [],
      retryingCouponIds: [],
      tableData: {
        list: [],
        total: 0
      },
      tableFrom: {}
    }, (0, _fliterConfig.default)({
      handleSearch: this.handleSearch
    })), (0, _paginationEffect.default)(this.handlerGetListData));
  },
  created: function created() {
    this.handlerGetListData(this.pageData);
  },
  mounted: function mounted() {
    // 在mounted后加载地区数据，确保Vue响应式系统已初始化
    this.loadAreaOptions();
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      return (0, _pageCache.refreshOnCacheReentry)(vm, vm.handlerGetListData);
    });
  },
  methods: {
    formatCodeGenStatus: function formatCodeGenStatus(row) {
      if (Number(row.isGenerateCode) !== 1 || row.codeGenStatus === null || row.codeGenStatus === undefined || row.codeGenStatus === '') {
        return '--';
      }
      var labels = {
        0: '未生成',
        1: '生成中',
        2: '已完成',
        3: '失败'
      };
      return labels[row.codeGenStatus] || '--';
    },
    conponAddOredit: function conponAddOredit(type, row) {
      var query = row ? {
        id: row.id
      } : {};
      this.$router.push({
        path: "/marketing/coupon/list/save/".concat(type),
        query: query
      });
    },
    detail: function detail(row) {
      this.$router.push({
        path: "/marketing/coupon/detail/".concat(row.id)
      });
    },
    effectAnalysis: function effectAnalysis(row) {
      this.$router.push({
        path: "/marketing/coupon/effectAnalysis/".concat(row.id)
      });
    },
    close: function close(row) {
      this.$refs.CloseCouponVueRef.open(row.id);
    },
    handlerDelete: function handlerDelete(row) {
      var _this = this;
      this.$confirm('确定删除当前数据', '提示').then(function (result) {
        (0, _api.deleteCouponsApi)(row.id).then(function (data) {
          _this.$message.success('删除数据成功');
          _this.handlerGetListData();
        });
      });
    },
    copyLink: function copyLink(row) {
      this.$refs.CopyLinkVueRef.open(row.id);
    },
    downloadCodes: function () {
      var _downloadCodes = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(row) {
        var res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (!this.downloadingCouponIds.includes(row.id)) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              this.downloadingCouponIds.push(row.id);
              _context.p = 2;
              _context.n = 3;
              return (0, _api.downloadCouponCodesApi)(row.id);
            case 3:
              res = _context.v;
              if (!(!res || !res.fileName)) {
                _context.n = 4;
                break;
              }
              this.$message.error('下载失败，未获取到券码文件');
              return _context.a(2);
            case 4:
              this.$download.url(res.fileName, res.fileName.substring(res.fileName.lastIndexOf('/') + 1));
              _context.n = 6;
              break;
            case 5:
              _context.p = 5;
              _t = _context.v;
            case 6:
              _context.p = 6;
              this.downloadingCouponIds = this.downloadingCouponIds.filter(function (id) {
                return id !== row.id;
              });
              return _context.f(6);
            case 7:
              return _context.a(2);
          }
        }, _callee, this, [[2, 5, 6, 7]]);
      }));
      function downloadCodes(_x) {
        return _downloadCodes.apply(this, arguments);
      }
      return downloadCodes;
    }(),
    retryGenerateCodes: function () {
      var _retryGenerateCodes = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(row) {
        var _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (!this.retryingCouponIds.includes(row.id)) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              this.retryingCouponIds.push(row.id);
              _context2.p = 2;
              _context2.n = 3;
              return (0, _api.retryGenerateCouponCodesApi)(row.id);
            case 3:
              this.$message.success('已提交券码重新生成请求');
              _context2.n = 4;
              return this.handlerGetListData();
            case 4:
              _context2.n = 6;
              break;
            case 5:
              _context2.p = 5;
              _t2 = _context2.v;
            case 6:
              _context2.p = 6;
              this.retryingCouponIds = this.retryingCouponIds.filter(function (id) {
                return id !== row.id;
              });
              return _context2.f(6);
            case 7:
              return _context2.a(2);
          }
        }, _callee2, this, [[2, 5, 6, 7]]);
      }));
      function retryGenerateCodes(_x2) {
        return _retryGenerateCodes.apply(this, arguments);
      }
      return retryGenerateCodes;
    }(),
    handleSearch: function handleSearch(data) {
      if (data) {
        this.tableFrom = _objectSpread({}, data);
      } else {
        this.tableFrom = {};
      }
      this.resetPageData();
    },
    handlerGetListData: function () {
      var _handlerGetListData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var params, data, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              this.listLoading = true;
              params = _objectSpread(_objectSpread({}, this.tableFrom), this.pageData); // 处理时间
              if (params.lifespanTime) {
                params.startTime = params.lifespanTime[0];
                params.endTime = params.lifespanTime[1];
                delete params.lifespanTime;
              }
              _context3.p = 1;
              _context3.n = 2;
              return (0, _api.couponslistApi)(params);
            case 2:
              data = _context3.v;
              this.tableData = data || {
                list: [],
                total: 0
              };
              this.listLoading = false;
              _context3.n = 4;
              break;
            case 3:
              _context3.p = 3;
              _t3 = _context3.v;
              this.listLoading = false;
            case 4:
              return _context3.a(2);
          }
        }, _callee3, this, [[1, 3]]);
      }));
      function handlerGetListData() {
        return _handlerGetListData.apply(this, arguments);
      }
      return handlerGetListData;
    }(),
    loadAreaOptions: function () {
      var _loadAreaOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res, areaItem, _t4;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              if (this.loadAreaData) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              _context4.p = 1;
              _context4.n = 2;
              return this.loadAreaData();
            case 2:
              res = _context4.v;
              // 使用$set确保响应式更新
              areaItem = this.FILTER_ITEMS.find(function (item) {
                return item.prop === 'areaScope';
              });
              if (areaItem && areaItem.attrs && res && Array.isArray(res)) {
                this.$set(areaItem.attrs, 'options', res);
              }
              _context4.n = 4;
              break;
            case 3:
              _context4.p = 3;
              _t4 = _context4.v;
              console.error('加载地区数据失败:', _t4);
            case 4:
              return _context4.a(2);
          }
        }, _callee4, this, [[1, 3]]);
      }));
      function loadAreaOptions() {
        return _loadAreaOptions.apply(this, arguments);
      }
      return loadAreaOptions;
    }(),
    getManualReceiveCount: function getManualReceiveCount(row) {
      var totalReceiveCount = row.receiveCount || 0;
      var backendIssueCount = row.backendIssueCount || 0;
      var purchaseIssueCount = row.purchaseIssueCount || 0;
      var integralExchangeIssueCount = row.integralExchangeIssueCount || 0;
      var codeBindIssueCount = row.codeBindIssueCount || 0;
      return Math.max(totalReceiveCount - backendIssueCount - purchaseIssueCount - integralExchangeIssueCount - codeBindIssueCount, 0);
    }
  }
};